import Service from '../service/Service';
const service = new Service();
import Cookies from "js-cookie";

var jcrop_api;
var cropped_img;
var stickerIdAry = [];

export function slideLeft(id, keyVal, eleRef, tool) {
    if (id > keyVal) {
        weekInfo(id - 1, eleRef, keyVal, tool);
    }
}
export function afterJcropFilesLoaded(fileObj) {
    var w = 0;
        var h = 0;
        var _URL = window.URL || window.webkitURL;
        var file, img;
        file = fileObj;
        img = new Image();
        img.onload = function () {
            w = this.width;
            h = this.height;
            if ($(window).width() > 767) {
                if (w > h) {
                    if ((w / h) > 2) {
                        $('#cropbox').addClass('landCropbox')
                    } else {
                        $('.img_cntner').css('height', '300px');
                        $('#cropbox').addClass('portCropbox')
                    }
                } else if (w < h) {
                    $('.img_cntner').css('height', '300px');
                    $('#cropbox').addClass('portCropbox')
                } else {
                    $('.img_cntner').css('width', '300px');
                    $('.img_cntner').css('height', '300px');
                    $('#cropbox').addClass('normalCropbox')
                }
                if (h > 400) {
                    $('.uploadImg-popup').css('top', '10%')
                }
            } else {
                if (w < h) {
                    if (((($(window).width() - 40) * h) / w) > ($(window).width() - 40)) {
                        $('.img_cntner').css('height', '300px');
                        $('#cropbox').addClass('portCropbox')
                    }
                }
            }
            var reader = new FileReader();
            reader.onload = function (e) {
                $('#cropbox').attr('src', e.target.result);
                $('#cropbox').Jcrop({
                    aspectRatio: 464 / 500,
                    setSelect: [0, 0, 200, 200],
                    boxWidth: 675,
                    allowResize: !0,
                    onSelect: updateCoords
                })
            };
            reader.readAsDataURL(file)
        };
        img.src = _URL.createObjectURL(file);
        $('.uploadImg-overlay').show();
        
}
function updateCoords(c) {
    $('#x').val(c.x);
    $('#y').val(c.y);
    $('#w').val(c.w);
    $('#h').val(c.h);
    // responsiveCoords(c, '#cropbox');
};

export function slideRight(id, keyVal, eleRef, tool) {
    if (id < 40) {
        weekInfo(id + 1, eleRef, keyVal, tool);
    }
}
export function changeTabTextColor(eleRef) {
    if (window.innerWidth > 767) {
        for (let i = 0; i < eleRef.state.cardList.length; i++) {
            eleRef.state.cardListmonth[i].classList["value"] = "month-old R14_9e";
            if (eleRef.state.cardList[i].classList.contains('active')) {
                eleRef.state.cardList[i].firstElementChild.lastChild.classList['value'] = 'month-old R14_pink';
            }
        }
    } else {
        for (let i = 0; i < eleRef.state.cardList.length; i++) {
            eleRef.state.cardListmonth[i].classList["value"] = "month-old R11_9e";
            if (eleRef.state.cardList[i].classList.contains('active')) {
                eleRef.state.cardList[i].firstElementChild.lastChild.classList['value'] = 'month-old R11_pink';
            }
        }
    }
}

export function calScrollTop(left, id,val,eleRef) {
    eleRef.state.cardsTotalHeight = 0;
    for (var m = 6; m < left; m++) {
        if ((window).outerWidth > 767) {
            eleRef.state.cardsTotalHeight += (document.querySelector('#month-card-' + m).offsetHeight + val);
          }
          else{
            eleRef.state.cardsTotalHeight += (document.querySelector('#month-card-' + m).offsetHeight);
          }
    }
    return eleRef.state.cardsTotalHeight;
}

export function isInViewport(el) {
    // console.log("element===============>",el);
    const scroll = window.scrollY || window.pageYOffset
    const boundsTop = el.getBoundingClientRect().top + scroll
    const viewport = {
        top: scroll,
        bottom: scroll + window.innerHeight,
    }
    const bounds = {
        top: boundsTop,
        bottom: boundsTop + el.clientHeight,
    }
    if(window.innerWidth < 767){
        return el.getBoundingClientRect().top >= 0 && el.getBoundingClientRect().bottom <= window.innerHeight
    }else{
        return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
        || (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
    }
}
// export function isInViewport(el) {
//     var elementTop = el.getBoundingClientRect().top + window.scrollY;
//     var elementBottom = elementTop + el.offsetHeight;
//     var viewportTop = window.pageYOffset;
//     if(window.innerHeight > 710 && window.innerWidth < 767){
//         var viewportBottom = viewportTop + window.innerHeight/2;
//     }else{
//         var viewportBottom = viewportTop + window.innerHeight;
//     }
//     return elementBottom > viewportTop && elementTop < viewportBottom
// }
export function slideStage(e,eleRef) {
    if (navigator.onLine) {
        if (e.target.parentElement.classList.contains('next')) {
            document.querySelector(".month-slider").scrollLeft = (document.querySelector(".month-slider").scrollLeft + 114);
            eleRef.state.myactiveStage += 114;
        } else {
            document.querySelector(".month-slider").scrollLeft = document.querySelector(".month-slider").scrollLeft - 114;
            eleRef.state.myactiveStage -= 114;
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function calScrollLeft(id ,val) {
    console.log("calScrolleft===========>",val);
    let id1 = parseInt(id);
    let monthSliderWidth = document.querySelector('.month-slider').offsetWidth;
    let tablinkBorderWidth = 1;
    let tablinkMarRight = 14;
    if (window.innerWidth < 767) {
        tablinkMarRight = 10;
        tablinkBorderWidth = 2
    }
    let tablinkWidth = (document.querySelector('.tablink') ? document.querySelector('.tablink').offsetWidth : 0) + (2 * tablinkBorderWidth);
    let tablinkTotalWidth = tablinkWidth + tablinkMarRight;

    let noOfTablink = (monthSliderWidth / tablinkTotalWidth) / 2;

    let activelinkLeft = (tablinkWidth * (noOfTablink - Math.floor(noOfTablink))) + (tablinkTotalWidth * (Math.floor(noOfTablink) - 1)) + (tablinkWidth / 2);

    if ((id1 + Math.floor(noOfTablink)) > val) {
        return document.querySelector('.month-slider').firstElementChild.offsetWidth;
    } else {
        return ((tablinkTotalWidth * (id1 - 1)) - activelinkLeft)
    }
}

export function weekInfo(weekno, eleRef, keyVal, tool) {
    if (navigator.onLine) {
        console.log("weekInfo==============>",weekno);
        eleRef.setState({ clickwedWeek: weekno });
        let currentindex = weekno - keyVal;
        let scrolllft = 0;
        for (let i = 1; i <= document.querySelectorAll('.week-bar li').length; i++) {
            let wd = i * eleRef.state.weekwd;
            if (wd > eleRef.state.halfwidth) {
                if (currentindex >= i - 1) {
                    scrolllft = ((currentindex - (i - 1)) * eleRef.state.weekwd);
                    if (tool == 'pis') {
                        let maxScroll = document.getElementsByClassName('pregn-reports-cnt')[0].offsetWidth - document.getElementsByClassName('preg-scroll')[0].offsetWidth;
                        scrolllft = scrolllft <= maxScroll ? scrolllft : maxScroll;
                        document.querySelector('.preg-scroll').scrollLeft = scrolllft;
                        document.getElementsByClassName('pregnancy-reports')[0].style.width = (document.getElementsByClassName('preg-scroll')[0].offsetWidth + scrolllft) + 'px';
                    } else {
                        let maxScroll = 0;
                        if (document.getElementsByClassName('week-bar') && document.getElementsByClassName('weeks-section')) {
                            maxScroll = document.getElementsByClassName('week-bar')[0].offsetWidth - document.getElementsByClassName('weeks-section')[0].offsetWidth;
                        }
                        scrolllft = scrolllft <= maxScroll ? scrolllft : maxScroll;
                        document.querySelector('.weeks-section').scrollLeft = scrolllft;
                    }
                    break
                } else {
                    if (tool == 'pis') {
                        document.querySelector('.preg-scroll').scrollLeft = scrolllft;
                        document.getElementsByClassName('pregnancy-reports')[0].style.width = document.getElementsByClassName('preg-scroll')[0].offsetWidth + 'px';
                    } else {
                        document.querySelector('.weeks-section').scrollLeft = scrolllft;
                    }
                    break
                }
            }
        }
        if (tool == 'bsc') {
            if (eleRef.state.babysizecomparisonData[weekno - keyVal]) {
                let articleCnt = eleRef.state.babysizecomparisonData[weekno - keyVal]['articles'].length;
                if (articleCnt > 0) {
                    let sliderFullWidth = (eleRef.state.sliderWidth + eleRef.state.marginRight) * articleCnt;
                    eleRef.setState({ sliderFullWidth: (sliderFullWidth + 10) + "px" });
                    // document.getElementById('sliderId').style.width = sliderFullWidth + "px"
                }
                let babylength = eleRef.state.babysizecomparisonData[weekno - keyVal].averageLength;
                document.querySelector('.baby-len').innerHTML = babylength;
                let babyweight = eleRef.state.babysizecomparisonData[weekno - keyVal].averageWeight;
                document.querySelector('.baby-wt').innerHTML = babyweight;
                eleRef.state.typename = document.querySelector('.selected').innerText.split(" ")[2];
                let imgtype = document.querySelector('.selected').innerText.split(" ")[2];
                eleRef.imagetype(imgtype);
                setTimeout(function () {
                    document.querySelector('.articles-slider').scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }, 100)
            }
        } else if (tool == 'wbw') {
            eleRef.selectimage(weekno, "scan_2D");
        } else if (tool == 'pis') {
            eleRef.setTrimesterText(weekno);
        }else if(tool == 'wbwG'){
            setTimeout(()=>{
            console.log("eleRef.state.clickwedWeek=========>",eleRef.state.clickwedWeek);
                document.querySelector('.baby-sizeCurrWk').innerText=(eleRef.state.clickwedWeek);
                document.querySelector('.length').innerHTML=(eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].length);
                document.querySelector('.weight').innerHTML=(eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].weight);
                document.querySelector('.trimester').innerHTML=(eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].trimester);
                if (!global.ftk || global.userAry['childData']['UserChildList'] == null || global.userAry['childData']['UserChildList'].length == 0 || !eleRef.state.IsExpected) {
                        document.querySelector('.trimesterdays').display='none';
                    } else if (eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].week == 40 && eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].daysLeft < 1) {
                            document.querySelector('.trimesterdays').display='none';
                        } else {
                                document.querySelector('.trimesterdays').display='show';
                                document.querySelector('.trimesterdays').innerText=(" | " + eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].daysLeft + " days left");
                            }
            },50);
            eleRef.selectimage(weekno, "scan_2D");
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function shareOn(id) {
    let ary = document.getElementsByClassName('sharing-options');
    // console.log("shareon "+ary.length);
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    // console.log(ary);
    // console.log(document.querySelector('.articles-section').getElementById('share_' + id));
    document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';

    if (window.innerWidth < 767) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'block';
    }
}

export function shareArticle(shareoption, articleurl) {
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if(document.getElementsByClassName('share-overlay')){
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption === "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption === "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption === "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption === "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    console.log("sharewindow " + sharewindow);
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

export function domClick(event) {
    // console.log("windowclick");
    if (!event.target.classList.contains('share-icon') && !event.target.classList.contains('share-text')) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
    }
}
export function duDateQans(id) {
    if (document.getElementById(id).firstElementChild.nextSibling.style.display != "none") {
        document.getElementById(id).firstElementChild.style.marginBottom = "10px"
        document.getElementById(id).nextSibling.style.display = "block";
        document.getElementById(id).firstElementChild.nextSibling.style.display = "none";
        document.getElementById(id).firstElementChild.nextSibling.nextSibling.style.display = "block";
    }
    else {
        document.getElementById(id).firstElementChild.style.marginBottom = "0px"
        document.getElementById(id).nextSibling.style.display = "none";
        document.getElementById(id).firstElementChild.nextSibling.style.display = "block";
        document.getElementById(id).firstElementChild.nextSibling.nextSibling.style.display = "none";
    }
}
export function loopCycle() {
    for (var i = 21; i < 36; i++) {
        <option value={i}>{i}</option>
    }
}

// export function Disclaimer(eleRef) {
//     eleRef.props.history.push("/tools/pregnancy-due-date-calculator/disclaimer");
// }

// export function FAQs(eleRef) {
//     eleRef.props.history.push("/tools/pregnancy-due-date-calculator/faqs");
// }

export function getPragnancyTrimesterText(week) {
    week = parseInt(week);
    let text = '';
    if (week <= 12) {
        text = "First Trimester";
    } else if (week <= 26 && week > 12) {
        text = "Second Trimester";
    } else if (week > 26) {
        text = "Third Trimester";
    }
    return text;
}

export function getDateStringPis(date) {
    if (date) {
        let monthAry = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        // let dateObj = new Date(date.replace(/-/g, '/'));
        let dateObj = new Date(date);
        var strDate = (dateObj.getDate() > 9 ? dateObj.getDate() : "0" + dateObj.getDate()) + " " + monthAry[dateObj.getMonth()] + " " + dateObj.getFullYear();
        return strDate;
        //console.log("set date:",strDate)
    } else {
        return "";
    }
}

export function getTimeStringPis(date) {
    if (date) {
        let dateObj = new Date(date.replace(/-/g, '/'));
        var hours = dateObj.getHours();
        var minutes = dateObj.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    } else {
        return "";
    }
}

export function getTimeValPis(date) {
    if (date) {
        let dateObj = new Date(date.replace(/-/g, '/'));
        var hours = dateObj.getHours();
        var minutes = dateObj.getMinutes();
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes;
        return strTime;
    } else {
        return "";
    }
}

export function removeSelfClass(add, remove) {
    setTimeout(() => {
        let count = document.querySelectorAll('.' + add).length;
        for (let i = 0; i < count; i++) {
            document.querySelectorAll('.' + add)[i].classList.add(remove);
        }
        let count1 = document.querySelectorAll('.' + remove).length;
        for (let j = 0; j < count1; j++) {
            document.querySelectorAll('.' + remove)[j].classList.remove(add);
        }
    }, 1000);
}

export function closeEmailPopup(event) {
    document.querySelector(".email-overlay").style.display = "none";
    document.querySelector(".email-tooltip").style.display = "none";
    // document.querySelector('.type-msg').value="";
}

export function sendFetusEmail() {
    if (global.ftk != '') {
        var _isemail = document.querySelector('#email_to').value;
        if (_isemail == '') {
            service.showAlert("Please enter a valid email address.");
            return false;
        }
        var emailText = document.querySelector('.type-msg').value;
        service.showLoader();
        var postData = {
            "emailTo": _isemail,
            "emailText": emailText
        }
        var url = global.api_ci_url + "Fetus/sendFetusEmail";
        service.postServiceCall(url, postData).then((json) => {
            service.hideLoader();
            service.showAlert("Mail sent successfully.");
            document.querySelector('.email-overlay').style.display = 'none';

        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}
export function selected_contest(title, contestId,eleRef) {
    if (document.querySelector(".selected_option") != null) {
        document.querySelector(".selected_option").innerHTML = title;
    }
    eleRef.state.contestId = contestId;
    document.querySelector(".options_overlay").style.display = "none";
    document.querySelector("#selconst").innerHTML = title;
    document.querySelector("#selconst").classList.add("R15_42");
    document.querySelector("#selconst").classList.remove("R15_9e");
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    // document.querySelector(".shareicon").attr("data-icon-font", "A"),
    // document.querySelector("#sharepic").addClass("isChecked")
}
export function showOptions() {
    if (window.innerWidth < 767) {
        var e = window.innerWidth - document.querySelector(".option_list").offsetWidth;
        document.querySelector(".option_list").css = ("left", e / 2)
    }
    document.querySelector(".options_overlay").style.display = "block";
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
}
export function myProfile_status(e) {
    if (e.target.classList.contains('isChecked')) {
        e.target.classList.remove('isChecked');
        e.target.setAttribute('data-icon-font', "z");
    } else {
        e.target.value = 1;
        e.target.classList.add('isChecked');
        e.target.setAttribute('data-icon-font', "A");
    }
}
export function pisTestdone(e,id,eleRef) {
 

    service.showLoader();
    if (e.target.classList.contains('isMarkChecked')) {
        e.target.classList.remove('isMarkChecked');
        setMarkDoneStatus(id,eleRef,0);
        e.target.setAttribute('data-icon-font', "z");
    } else {
        e.target.value = 1;
        setMarkDoneStatus(id,eleRef,1);
        e.target.classList.add('isMarkChecked');
        e.target.setAttribute('data-icon-font', "A");
    }
    service.hideLoader();
}
export function pisTogglegraph(e,eleRef) {
    service.showLoader();
   
    if (e.target && e.target.classList && e.target.classList.contains('toggle_pis')) {
        eleRef.pisData("GraphView");
        Cookies.set("chartType" ,"GraphView");
        e.target.classList.remove('toggle_pis');
        document.querySelector(".ganchart-view-pis").classList.add("slide-tag-active");
        document.querySelector(".ganchart-mobile-view-pis").classList.add("pis_mobile_design_active");
        document.querySelector(".nutritional.pis-add-cl").classList.add("slide-tag-active2");
        document.querySelector(".pie_chart2") && (document.querySelector(".pie_chart2").style.display="none");
        document.querySelector(".contentList").style.display="none";

    } else {
        eleRef.pisData("Piechart");
        Cookies.set("chartType","Piechart");
        e.target.value = 1;
        e.target.classList.add('toggle_pis');
        document.querySelector(".pie_chart2") && (document.querySelector(".pie_chart2").style.display="block");
        document.querySelector(".contentList").style.display="block";
        document.querySelector(".ganchart-view-pis").classList.remove("slide-tag-active");
        document.querySelector(".ganchart-mobile-view-pis").classList.remove("pis_mobile_design_active");
        document.querySelector(".nutritional.pis-add-cl").classList.remove("slide-tag-active2");
    }
    setTimeout(()=>{
        service.hideLoader();
    },1000)
}
function setMarkDoneStatus(id,eleRef,status) {
    var date = new Date().getFullYear()+ "-" + (new Date().getMonth()+1) +"-"+ new Date().getDate();
    if (global.ftk != '') {
        service.showLoader();
        if(status==1){
            var postData = {
                "testid": id,
                "comment": "",
                "imageurl": "",
                "markdate": getDateStringPis(date)
            }
            // var url = global.api_ci_url + "Pis/setMarkDoneStatus";
            var url = global.api_ci_url + "api/fetchfromCI/preginspection~setmarkdonestatus";
        }else{
            var postData = {
                "testid": id
            }
            // var url = global.api_ci_url + "Pis/setUnmarkdoneStatus";
            var url = global.api_ci_url + "api/fetchfromCI/preginspection~setunmarkdoneStatus";

        }

        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (parseInt(json['msg']) == 1) {
                // this.setState({ testSaveStatus: true });
                eleRef.pisData("Piechart");
            } else {
                service.showAlert("Fail");
            }
            // service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function pispiechart(sublistul, clr, eleRef) {
     // if (window.innerWidth < 767) {
     //      var windowWidth=69;
     //      }else{
     //      var windowWidth=69;
     //    }
    

    var borderW = 0;
    if(eleRef.state.IsExpected){
        borderW = 10;
        Chart.pluginService.register({
            afterUpdate: function (chart) {
            for (let i = 1; i < chart.config.data.labels.length; i++){

                var arc = chart.getDatasetMeta(0).data[i];
                arc.round = {
                x: (chart.chartArea.left + chart.chartArea.right) / 2,
                y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
                radius: (chart.outerRadius + chart.innerRadius) / 2,
                thickness: 13.4,
                backgroundColor: arc._model.backgroundColor
                } 
            
            }
            // Draw rounded corners for first item
            var arc = chart.getDatasetMeta(0).data[0];
            arc.round = {
                x: (chart.chartArea.left + chart.chartArea.right) / 2,
                y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
                radius: (chart.outerRadius + chart.innerRadius) / 2,
                thickness: 13.4,
                backgroundColor: arc._model.backgroundColor
            } 
            },
            
            afterDraw: function (chart, arc) {
            for (let i = 1; i < chart.config.data.labels.length; i++){
                var ctx = chart.chart.ctx;  arc = chart.getDatasetMeta(0).data[i];
                var startAngle = Math.PI / 2 - arc._view.startAngle;
                var endAngle = Math.PI / 1.98 - arc._view.endAngle;
                ctx.save();
                ctx.translate(arc.round.x, arc.round.y);
                ctx.fillStyle = arc.round.backgroundColor;
                ctx.beginPath();
                ctx.arc(arc.round.radius * Math.sin(endAngle), arc.round.radius * Math.cos(endAngle), arc.round.thickness, 0, 2 * Math.PI);
                ctx.closePath(); ctx.fill(); ctx.restore();
            }
            // Draw rounded corners for first item
            var ctx = chart.chart.ctx; arc = chart.getDatasetMeta(0).data[0];
            var startAngle = Math.PI / 2 - arc._view.startAngle;
            var endAngle = Math.PI / 1.98 - arc._view.endAngle;
            ctx.save();
            ctx.translate(arc.round.x, arc.round.y);
            ctx.fillStyle = arc.round.backgroundColor;
            ctx.beginPath();
            // ctx.arc(arc.round.radius * Math.sin(startAngle), arc.round.radius * Math.cos(startAngle), arc.round.thickness, 0, 2 * Math.PI);
            ctx.arc(arc.round.radius * Math.sin(endAngle), arc.round.radius * Math.cos(endAngle), arc.round.thickness, 0, 2 * Math.PI);
            ctx.closePath(); ctx.fill(); ctx.restore();
            },
        });

        
    }
    var config = {
    type: 'doughnut',
    data: {
      labels: ['a', 'b', 'v'],
      datasets: [{
        data: sublistul,
        backgroundColor: clr,
        borderWidth: borderW,
        borderColor: ["#eeeeee","#eeeeee", "#eeeeee" ],
        hoverBorderColor: '#eeeeee'
      },]
    },
    options: {
        // responsive: false,
        maintainAspectRatio: true,
        showScale: false,
      legend: {
        display: false,
        position: 'bottom',
        backgroundColor: ["#ee534f","#ee534f", "#ee534f" ],
        reverse: true,
        labels: {
          padding: 40,
          fontSize: 12,
          fontColor: 'rgb(0, 0, 0)'
        }
      },
      tooltips: {
        enabled: false,
      },
      hover: false,
      // cutoutPercentage: windowWidth, 
       cutoutPercentage: 69,     
      rotation: -0.5 * Math.PI,
      circumference: 2 * Math.PI,
      animation: {
        animateScale: true,
        animateRotate: true
      },
      elements: {
        center: {
          // the longest text that could appear in the center  7,500,000 /10,000,000
          maxText: '100%',
          text: '',
          fontColor: '#000',
          fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          fontStyle: 'bold',
          minFontSize: 1,
          maxFontSize: 356,
        }
      }
    }
  };
// window.onload = function() {
  var ctx = document.getElementById('myChart').getContext('2d');
  window.myDoughnut = new Chart(ctx, config);
  // window.myDoughnut.generateLegend();
// };
}

export function SlideTag(e, eleRef) {
    if (eleRef.state.insertIds.length < 1 && (document.querySelector(".slide-tag-active") == null || document.querySelector(".slide-tag-active"))) {
        if (document.querySelector(".slide-tag-active") != null) {
            for (var a = 0; a < document.querySelector(".slide-tag-active").length; a++) {
                eleRef.state.insertIds.push(document.querySelector(".slide-tag-active")[a].getAttribute("data-id"));
            }
        }
        if (e.target.getAttribute("data-id") == "1" && document.querySelector(".tagkids_1").classList.contains("slide-tag-active")) {
            document.querySelector(".tagkids_1").classList.remove("slide-tag-active");
            document.querySelector("#setmyselfval").value = "0";
        } else {
            document.querySelector(".tagkids_1").classList.remove("slide-tag-active");
            document.querySelector(".tagkids_1").classList.add("slide-tag-active");
            document.querySelector("#setmyselfval").value = "1";
        }
    }
}

// new function 3



export function checkCoords(eleRef, feature) {
    console.log("---- checkCoords CALLED ----");

    const size = getResponsiveCoords('#cropbox');
    const imageObj = document.getElementById("cropbox");

    const frameSrc = document.getElementById("main_frame")?.src;
    const dateText = document.querySelector(".face_date_container_uf")?.innerText || "";

    const canvas = document.getElementById("preview");
    const ctx = canvas.getContext("2d");

    // Load frame first
    const frameImg = new Image();
    frameImg.crossOrigin = "anonymous";
    frameImg.src = frameSrc;

    frameImg.onload = function () {

        canvas.width = frameImg.naturalWidth || 464;
        canvas.height = frameImg.naturalHeight || 500;

        console.log("Canvas size set to:", canvas.width, canvas.height);

        ctx.drawImage(
            imageObj,
            size.x, size.y, size.w, size.h,
            0, 0,
            canvas.width, canvas.height
        );

        // 2️⃣ Draw Frame Overlay
        ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);

        // 3️⃣ Draw Date Text
        const dateEle = document.querySelector(".face_date_container_uf");
        if (dateText.length > 0) {
            ctx.font = "bold 40px Arial";
            ctx.fillStyle = "white";
            ctx.textAlign = "center";

            const paddingBottom = 40;
            const frameOffset = frameImg.getBoundingClientRect();
            const dateOffset = document.querySelector(".face_date_container_uf").getBoundingClientRect();
          
            // For mobile, center the text horizontally
            let x;
            let f_font_size;
            if (window.innerWidth < 768) {
                x = dateOffset.left + (dateOffset.width + (40*3));
                f_font_size = parseFloat(getComputedStyle(dateEle).fontSize) * 3 + "px";
            } else {
                x = dateOffset.left - frameOffset.left - 40;
                f_font_size = parseFloat(getComputedStyle(dateEle).fontSize) * 2 + "px";
            }
            const y = canvas.height - paddingBottom;

            const f_font_family = getComputedStyle(dateEle).fontFamily;
            // const 
            const f_font_weight = getComputedStyle(dateEle).fontWeight;

            ctx.font = `${f_font_weight} ${f_font_size} ${f_font_family}`;

            ctx.fillStyle = "#fff";

            ctx.fillText(dateText, x, y);
        }

        // Final merged PNG
        const finalDataUrl = canvas.toDataURL("image/png");

        console.log("Final Data URL generated");

        // Mobile
        // if (feature === "FB" && window.innerWidth < 768) {
        //     eleRef.setState({ isMemoryCropped: true }, () => {
        //         $(".before_crop").hide();
        //         $("#aftercropimg").attr("src", finalDataUrl);
        //         $(".after_crop").show();
        //         cropped_img = finalDataUrl;
        //     });
        //     return;
        // }

        // Convert to File
        const fileInput = document.getElementById("face_upload");
        const fileName = fileInput?.files?.[0]?.name || "merged.png";
        const file = dataURItoFile_new(finalDataUrl, fileName);
        uploadMemoryImgSubmit(file, eleRef, feature);
    };

    frameImg.onerror = function () {
        console.error("Error loading frame image");
    };
}


export function dataURItoFile_new(dataURI, file_name) {
    file_name = Math.round(new Date().getTime() / 1000) + ".png";
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], file_name, { type: mimeString });
}


export function dataURItoFile(dataURI,ids) {
    console.log("dataURItoFile");
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], document.getElementById(ids).files[0]['name'], { type: mimeString });
}


export function clearMemoryImageData(eleRef,tool,flag) {

    console.log("clearMemoryImageData", flag);
    console.log("clearMemoryImageData - eleRef", eleRef);
    document.getElementsByClassName('uploadImg-overlay')[0].style.display = "none";
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    // document.getElementById(ids).value = '';
    document.getElementsByClassName('img_cntner')[0].style.height = 'auto';


    eleRef.setState({ isMemorySelected: flag, cropedImagePath: ''}, () => {
        document.getElementById("face_upload").value = null;
        $('.uploadImg-overlay').hide();
        $('body').css("overflow", "visible");
        $('#cropbox').attr('src', "");
        jcrop_api = $('#cropbox').data('Jcrop');
        jcrop_api && jcrop_api.destroy();
        var canvas = $("#preview")[0];
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        var canvas1 = $("#finalcanvas")[0];
        var context1 = canvas1.getContext("2d");
        context1.clearRect(0, 0, canvas1.width, canvas1.height);
        $('.img_cntner.before_crop').css('width', 'auto');
        $('.img_cntner.before_crop').css('height', 'auto');
        $('#cropbox').removeClass('landCropbox');
        $('#cropbox').removeClass('portCropbox');
        $('#cropbox').removeClass('normalCropbox');
        if ($(window).width() < 767) {
            $('#cropbox').width(0);
        }
        resetStickers(eleRef, flag);
    });

}



export function resetStickers(eleRef, flag) {
    $('.before_crop').show();
    $('.before_crop img').attr('src', "");
    $('#cropbox').attr('src', "");
    $('.after_crop').hide();
    $('.after_crop img').attr('src', "");
    cropped_img = undefined;
    $('#mileFrame').attr('src', "");
    $('#mileFrame').hide();
    eleRef.setState({
        isMemoryCropped: false,
        selStickersAry: []
    });
    if (!flag) {
        eleRef.setState({
            isMilestoneUpload: false
        });
    }
}


export function ClosePopup(flag) {
    var ids;
    if(flag=="MB"){
        ids="mybumpie_upload";
    }else{
        ids="face_upload";
    }
    document.getElementsByClassName('uploadImg-overlay')[0].style.display = "none";
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementById(ids).value = '';
    document.getElementsByClassName('img_cntner')[0].style.height = 'auto';
    document.querySelector(".img_cntner").style.width = "auto";
}
export function shareArticleFrame(articleurl, shareoption) {
    console.log("shareoption=================>", shareoption, articleurl);
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    // if(document.getElementsByClassName('share-overlay')){
    //     document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    // }
    if (shareoption === "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption === "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption === "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption === "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    //console.log("sharewindow ",sharewindow);
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}
export function uploadMemoryImgSubmit(file,eleRef,flag) {

    console.log("uploadMemoryImgSubmit----------------->", flag);

    var ids;
    if(flag=="MB"){
        ids="mybumpie_upload";
    }else{
        ids="face_upload";
    }
    var fileObj = document.getElementById(ids).files[0];
    var apiurl = "";
    document.getElementsByClassName('file_upload_err')[0].innerHTML = '';
    if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png" || fileObj.type == "image/JPG") && file.size < 8388608) {
        var file_name = Math.round(new Date().getTime() / 1000) + "_" + file.name;
        // apiurl = global.api_url + "uploadMemoryImage";
        apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
    } else {
        document.getElementsByClassName('uploadImg-overlay')[0].style.display = "none";
        document.getElementsByTagName('body')[0].style.overflow = 'visible';
        return document.getElementsByClassName('file_upload_err')[0].style.display = "inline-block",
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "Only JPEG, JPG and PNG files allowed",
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible",
            document.getElementsByClassName('file_upload_err')[0].style.height = "30px";
    }
    service.postFileServiceCall(apiurl, file, file_name).then((json) => {
        console.log("API Responce" + json['result'])
        var dataAry = [];
        dataAry.push(json['result']);
        if (json['result'] == "success") {
            console.log("success");
            eleRef.setState({
                cropedImagePath: json['image_url'].replace("http://", "https://")
            });
            if (json['image_url']) {
                document.getElementById("main_frame").setAttribute("src", json['image_url'].replace("http://", "https://"));
            } else {
                document.getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
                document.getElementsByClassName('file_upload_err')[0].style.height = "10px";
                document.getElementsByClassName('file_upload_err')[0].style.html = "";
            }
            document.querySelector('.add_photo_lbl').style.display = "none";
            document.getElementsByClassName('photo_frame')[0].style.height = 'auto';
            document.getElementsByClassName('photo_frame')[0].style.backgroundColor = '#fff';
            document.getElementById('main_frame').style.display = "block";
            document.querySelector('.choose_photo_btns').style.display = "none";
            // document.querySelector('.face_day_container_uf').style.display = "none";
            if(flag=="FB"){
                document.querySelector('.face_date_container_uf').style.display = "none";
            }
            document.querySelector('.upload_photo_btns').style.display = "block";
            // document.getElementsByClassName('cancle_btn')[0].style.display="show";
        } else {
            console.log("API Responce sg sfd dsf gsdf");
            document.getElementsByClassName('file_upload_err')[0].style.display = "block";
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
            document.getElementsByClassName('file_upload_err')[0].style.height = "30px";
            document.getElementsByClassName('file_upload_err')[0].innerHTML = json['result'];
        }
        clearMemoryImageData(ids);
        document.getElementsByClassName("loader-overlay")[0].style.display = "none";
    })
}

function getResponsiveCoords(imgSelector) {
    var imgOrignalWidth = $(imgSelector).prop('naturalWidth');
    var imgOriginalHeight = $(imgSelector).prop('naturalHeight');

    var imgResponsiveWidth = parseInt($('.jcrop-holder').width());
    var imgResponsiveHeight = parseInt($('.jcrop-holder').parent().height());

    var responsiveX = Math.ceil(($('#x').val() / imgResponsiveWidth) * imgOrignalWidth);
    var responsiveY = Math.ceil(($('#y').val() / imgResponsiveHeight) * imgOriginalHeight);

    var responsiveW = Math.ceil(($('#w').val() / imgResponsiveWidth) * imgOrignalWidth);
    var responsiveH = Math.ceil(($('#h').val() / imgResponsiveHeight) * imgOriginalHeight);

    return {
        x: parseInt(responsiveX),
        y: parseInt(responsiveY),
        w: parseInt(responsiveW),
        h: parseInt(responsiveH)
    };
}

